import { UpdatesFilter } from 'actions/content/updates';
import { withPagination } from 'apis/utils';
import config from 'config';
import useSWR, { invalidateStartsWith } from 'hooks/useSWR';
import { PaginatedResult } from 'types';
import { PaginationOptions } from 'types/api';
import { CommunityUpdate } from 'types/content';
import { useSWRResource } from 'util/resource/useSWRResource';

export const communityUpdatesKey = (
  communityId: number,
  filterBy: UpdatesFilter,
  paginationOptions: PaginationOptions,
  topicId?: string,
) => {
  const byCompanyId = filterBy.type === 'my updates' ? filterBy.companyId : undefined;
  const filterByParams = filterBy.type === 'archive' ? { archived: true } : byCompanyId ? { byCompanyId } : {};
  const topicParams = topicId ? { topicId } : {};
  const params = Object.assign(filterByParams, topicParams);
  const url =
    filterBy.type === 'archive'
      ? `${config.COMPANIES_API_URL}/companies/${communityId}/updates`
      : `${config.COMPANIES_API_URL}/communities/${communityId}/updates`;

  return withPagination(url, paginationOptions, params);
};

export const reloadAllUpdates = (communityId: number) => {
  invalidateStartsWith([
    `${config.COMPANIES_API_URL}/companies/${communityId}/updates`,
    `${config.COMPANIES_API_URL}/communities/${communityId}/updates`,
  ]);
};

export function useCommunityUpdates(
  communityId: number,
  paginationOptions: PaginationOptions,
  filterBy: UpdatesFilter,
  topicId?: string,
) {
  const swrResult = useSWR<PaginatedResult<CommunityUpdate>>(
    communityUpdatesKey(communityId, filterBy, paginationOptions, topicId),
    undefined,
    {
      revalidateIfStale: true,
    },
  );

  return useSWRResource(swrResult);
}
